export type PayslipLang = 'en' | 'mn' | 'ru'

export const PAYSLIP_LANGS: readonly PayslipLang[] = ['en', 'mn', 'ru']

/** The payslip opens in the viewer's UI language, English when that is not one the PDF prints in. */
export function defaultPayslipLang(uiLanguage: string | undefined): PayslipLang {
  const code = uiLanguage?.toLowerCase().slice(0, 2)
  return code === 'mn' || code === 'ru' ? code : 'en'
}
